import store from '@/store/index';
const { userCode } = store.getters.user;
const EDIT_TYPE = {
    EDIT: 2,
    CANCEL: -3
};
export const tableConfig = {
    selection: false,
    height: 325,
    columns: [
        {
            label: '客户一页纸名称',
            prop: 'pageName',
            type: 'slot',
            editSlot: true,
            slot: true,
            width: 170
        },
        {
            label: '客户系',
            prop: 'customerGroupCode',
            type: 'slot',
            editSlot: true,
            slot: true,
            optionsKey: 'SYS_CUST_RELATION_TYPE'
        },
        {
            label: '客户系经理',
            prop: 'customerManagerName',
            width: 100
        },
        {
            label: '生成人',
            prop: 'pageOwnerName',
            width: 90
        },
        {
            label: '文档状态',
            prop: 'pageStatus',
            // type: 'select',
            type: 'slot',
            editSlot: true,
            slot: true,
            optionsKey: 'LCRM_CUSTOMER_PAGE_STATUS'
        },
        {
            label: '生成日期',
            prop: 'createTime',
            width: 100
        },
        {
            label: '版本号',
            prop: 'versionCode',
            width: 110
        },
        {
            label: '附件',
            type: 'slot',
            slot: true,
            editSlot: true,
            prop: 'fileName',
            width: 154
        }
    ],
    actions: { // 表格操作列的配置
        fixedWidth: 120, // fixedWidth（可选） 设置操作列的固定宽度，不加该参数默认是按钮list长度*50px
        list: [
            // 0-草稿；1-成稿；2-废弃
            {
                label: '废弃',
                event: 'abandon',
                displayRule: (row) => {
                    return +row.edit === EDIT_TYPE.CANCEL && ['1'].includes(row.pageStatus?.toString()) && (row.managerRole || userCode === row.createUserCode);
                }
            },
            {
                label: '删除',
                event: 'delete',
                displayRule: (row) => {
                    return +row.edit === EDIT_TYPE.CANCEL && ['0'].includes(row.pageStatus?.toString()) && (row.managerRole || userCode === row.createUserCode);
                }
            },
            {
                label: '废弃重启',
                event: 'reboot',
                displayRule: (row) => {
                    return +row.edit === EDIT_TYPE.CANCEL && ['2'].includes(row.pageStatus?.toString()) && (row.managerRole || userCode === row.createUserCode);
                }
            }
        ]
    }
};
